import { Auth } from "@/api/services/auth";

export const authService: Auth = new Auth();
